import Main from './Main'
import Lista from './components/Contratos'
import Novo from './components/NovoContrato'

export default [
  {
    path: 'contratos',
    name: 'config.contratos',
    component: Main,
    redirect: { name: 'config.contratos.list' },
    children: [
      {
        path: '/',
        name: 'config.contratos.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.contratos.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.contratos.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/contratos/routes.js